import { getField, updateField } from 'vuex-map-fields';
import { createStore } from 'vuex';

const initialState = {
  loggedIn: false,
  revisions: [],
  cards: [],
  board: {},
  loading: true,
  interval: null,
  project: {},
};

const getters = {
  getField,
};

const mutations = {
  updateField,
};

const actions = {};

export default createStore({
  namespaced: true,
  state: initialState,
  actions,
  mutations,
  getters,
});
